import user from '../user';

interface StoreProctoring {
  url: string;
  name: string;
  typeMaterial: string;
  currentUserIndex: number | null;
  users: User[];
  currentUser: User | null;
}

type StoreProctoringMutations = {
  [key: string]: (store: StoreProctoring, ...args: any[]) => any;
};
type StoreProctoringGetters = StoreProctoringMutations;

const proctoring: StoreProctoring = {
  url: '',
  name: '',
  typeMaterial: '',
  currentUserIndex: null,
  users: [],
  currentUser: null,
};

// TODO: ПЕРЕПИСАТЬ МУТАЦИИ, ЭКШОНЫ И ГЕТТЕРЫ НА камелКейс
const getters: StoreProctoringGetters = {
  currentUser(state) {
    if (state.currentUserIndex === null) return null;
    return state.currentUser;
  },
  getIndexById: state => (id: number) => {
    return state.users.findIndex(user => Number(user.MID) === Number(id));
  },
  GET_URL(state: StoreProctoring) {
    return state.url;
  },
  GET_NAME(state: StoreProctoring) {
    return state.name;
  },
  GET_TYPE_MATERIAL(state: StoreProctoring) {
    return state.typeMaterial;
  },
  GET_CURRENT_USER_INDEX(state: StoreProctoring) {
    return state.currentUserIndex;
  },
  GET_USERS(state: StoreProctoring) {
    return state.users;
  },
};

// TODO: ПЕРЕПИСАТЬ МУТАЦИИ, ЭКШОНЫ И ГЕТТЕРЫ НА камелКейс
const mutations: StoreProctoringMutations = {
  setUrl(state, data: string) {
    state.url = data;
  },
  SET_NAME(state, data: string) {
    state.name = data;
  },
  setTypeMaterial(state, data: string) {
    state.typeMaterial = data;
  },
  SET_CURRENT_USER_INDEX(state, data: string) {
    state.currentUserIndex = state.users.map(item => item.url).indexOf(data);
  },
  CHANGE_CURRENT_USER_INDEX(state, data: any) {
    state.currentUserIndex = data;
  },
  setUsers(state, data: any) {
    state.users = data;
  },
  setCurrentUser(state, data: User) {
    state.currentUser = data;
  },
};
// TODO: ПЕРЕПИСАТЬ МУТАЦИИ, ЭКШОНЫ И ГЕТТЕРЫ НА камелКейс
const actions = {
  setUser(
    { commit, getters }: { commit: any; getters: any },
    data: User | null
  ) {
    commit('setUrl', data && data.url);
    commit('SET_NAME', data && data.name);
    commit('SET_CURRENT_USER_INDEX', data && data.url);
    commit(
      'CHANGE_CURRENT_USER_INDEX',
      data && getters.getIndexById(data.user_id)
    );
  },
};

export default {
  namespaced: true,
  state: proctoring,
  getters,
  mutations,
  actions,
};
